export const POST_PHONE_REQUEST = 'POST_PHONE_REQUEST';
export const POST_PHONE_SUCCESS = 'POST_PHONE_SUCCESS';
export const POST_PHONE_ERROR = 'POST_PHONE_ERROR';

export const POST_LOGIN_REQUEST = 'POST_LOGIN_REQUEST';
export const POST_LOGIN_SUCCESS = 'POST_LOGIN_SUCCESS';
export const POST_LOGIN_ERROR = 'POST_LOGIN_ERROR';

export const POST_PROFILE_REQUEST = 'POST_PROFILE_REQUEST';
export const POST_PROFILE_SUCCESS = 'POST_PROFILE_SUCCESS';
export const POST_PROFILE_ERROR = 'POST_PROFILE_ERROR';

export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_ERROR = 'GET_USER_ERROR';

export const USER_LOGOUT = 'USER_LOGOUT';
export const UPDATE_USER = 'UPDATE_USER';
